module.exports = __webpack_public_path__ + "static/media/Purpose_25.66820b27.png";